<template>
  <div>
    <titulo-modulo titulo="Candidatura Interna" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else-if="candidato">
      <v-tabs v-model="tab" background-color="transparent" color="primary">
        <v-tab>CANDIDATURA</v-tab>
        <v-tab>HISTÓRICO</v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="tab"
        class="transparent tabs-items"
        style="min-height: 0"
      >
        <v-tab-item class="tab-item">
          <div class="tab-content">
            <v-stepper v-model="step" class="mt-3">
              <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1" color="info">
                  Selecionar vaga de interesse
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2" color="info">
                  Atualizar informações
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3" color="info">
                  Motivo da solicitação
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <vagas-interesse />
                </v-stepper-content>
                <v-stepper-content step="2">
                  <atualizar-informacoes />
                </v-stepper-content>
                <v-stepper-content step="3">
                  <motivo-solicitacao />
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </div>
        </v-tab-item>

        <v-tab-item class="tab-item">
          <div class="tab-content">
            <historico-candidaturas />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import VagasInteresse from "./components/VagasInteresse.vue";
import AtualizarInformacoes from "./components/AtualizarInformacoes.vue";
import MotivoSolicitacao from "./components/MotivoSolicitacao.vue";
import HistoricoCandidaturas from "./components/HistoricoCandidaturas.vue";
import axios from "axios";
//import { removeAcento } from "@/global";

export default {
  components: {
    TituloModulo,
    AtualizarInformacoes,
    VagasInteresse,
    MotivoSolicitacao,
    HistoricoCandidaturas,
  },
  computed: mapState("candidaturainterna", ["step", "candidato"]),
  data: () => ({
    tab: 0,
    carregando: false,
  }),
  methods: {
    ...mapMutations("candidaturainterna", [
      "setCandidato",
      "setSelecionaEscolaridade",
    ]),
    async getDadosCandidato() {
      this.carregando = true;
      await axios
        .get("/colaborador/candidatura-interna")
        .then((res) => {
          if (res.data.data) {
            this.setCandidato(res.data.data);
            this.setSelecionaEscolaridade(res.data.data.codescolaridade);
            //this.candidato.cidade = removeAcento(this.candidato.cidade);
          }
        })
        .catch((e) => this.$toasted.error(e));
      this.carregando = false;
    },
  },
  async mounted() {
    await this.getDadosCandidato();
  },
};
</script>

<style>
.transparent {
  background-color: transparent !important;
}

.tabs-items {
  min-height: 0 !important;
}

.tab-content {
  min-height: 0 !important;
}

.tab-item {
  min-height: 0 !important;
}

.v-window-item {
  align-items: flex-start !important;
}
</style>
